'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _toConsumableArray = require('@babel/runtime-corejs3/helpers/toConsumableArray');
var _Map = require('@babel/runtime-corejs3/core-js-stable/map');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _reduceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/reduce');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _findInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/find');
require('../expression/index.js');
require('../topology/index.js');
require('../data/index.js');
var graph_model = require('../topology/graph.model.js');
var attributeType_model = require('../topology/attribute-type.model.js');
var expression_model = require('../expression/expression.model.js');
var dataType_enum = require('../data/data-type.enum.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _Map__default = /*#__PURE__*/_interopDefaultLegacy(_Map);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _reduceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_reduceInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _findInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_findInstanceProperty);

var aliasSchemaAffix = 'alias_schema';
var AliasSchemaType = /*#__PURE__*/function (AliasSchemaType) {
  AliasSchemaType[AliasSchemaType["INITIAL_ALIAS_SCHEMA"] = 0] = "INITIAL_ALIAS_SCHEMA";
  AliasSchemaType[AliasSchemaType["ORDER_BY_ALIAS_SCHEMA"] = 1] = "ORDER_BY_ALIAS_SCHEMA";
  AliasSchemaType[AliasSchemaType["PATTERN_VIEW_ALIAS_SCHEMA"] = 2] = "PATTERN_VIEW_ALIAS_SCHEMA";
  return AliasSchemaType;
}({});

/**
 * Build alias schema based on the pattern.
 *
 * @export
 * @param {Graph} schema
 * @param {PatternJson} patternJson
 * @param {AliasSchemaType} aliasSchemaType
 * @returns {Graph}
 */
function buildAliasSchema(schema, patternJson, aliasSchemaType) {
  var _context, _context2, _context3, _context8;
  if (!schema || !patternJson) {
    return undefined;
  }
  var vertexJsons = [];
  var edgeJsons = [];
  switch (aliasSchemaType) {
    case AliasSchemaType.INITIAL_ALIAS_SCHEMA:
    case AliasSchemaType.ORDER_BY_ALIAS_SCHEMA:
      // <key = vertex set id, value = vertex set alias>
      var id2Alias = new _Map__default["default"]();

      // Collect vertext sets.
      _forEachInstanceProperty__default["default"](_context = patternJson.patternVertexSets).call(_context, function (vertexSet) {
        var alias = getPatternComponentAlias(vertexSet);
        id2Alias.set(vertexSet.id, alias);
        var attrJsons = getAttributeJsons(schema, vertexSet);
        if (aliasSchemaType === AliasSchemaType.ORDER_BY_ALIAS_SCHEMA) {
          addAttachmentsToAttributes(vertexSet, attrJsons);
        }
        vertexJsons.push(constructGSQLVertexJson(alias, attrJsons, vertexSet));
      });

      // Collect edge sets.
      _forEachInstanceProperty__default["default"](_context2 = patternJson.patternEdgeSets).call(_context2, function (edgeSet) {
        edgeJsons.push(constructGSQLEdgeJson(getPatternComponentAlias(edgeSet), id2Alias.get(edgeSet.sourcePatternId), id2Alias.get(edgeSet.targetPatternId), getAttributeJsons(schema, edgeSet), edgeSet));
      });
      break;
    case AliasSchemaType.PATTERN_VIEW_ALIAS_SCHEMA:
      _forEachInstanceProperty__default["default"](_context3 = patternJson.patternViews).call(_context3, function (patternView) {
        var _context4, _context6;
        var attrJsons = [];

        // Collect vertex sets that have an alias within the pattern view.
        _forEachInstanceProperty__default["default"](_context4 = patternView.vertexSetIds).call(_context4, function (vertexSetId) {
          var vertexSet = getPatternEntityJsonById(vertexSetId, patternJson);
          if (!vertexSet.alias) {
            return;
          }
          var attrJsonsInVertexSet = getAttributeJsons(schema, vertexSet);
          addAttachmentsToAttributes(vertexSet, attrJsonsInVertexSet);
          // The attribute name should start with the vertex set alias
          // to avoid duplicate attribute names within a pattern view.
          _forEachInstanceProperty__default["default"](attrJsonsInVertexSet).call(attrJsonsInVertexSet, function (attrJson) {
            var _context5;
            attrJson.AttributeName = _concatInstanceProperty__default["default"](_context5 = "".concat(vertexSet.alias, "_")).call(_context5, attrJson.AttributeName);
          });
          attrJsons.push.apply(attrJsons, attrJsonsInVertexSet);
        });

        // Collect edge sets that have an alias within the pattern view.
        _forEachInstanceProperty__default["default"](_context6 = patternView.edgeSetIds).call(_context6, function (edgeSetId) {
          var edgeSet = getPatternEntityJsonById(edgeSetId, patternJson);
          if (!edgeSet.alias) {
            return;
          }
          var attrJsonsInEdgeSet = getAttributeJsons(schema, edgeSet);
          // The attribute name should start with the edge set alias
          // to avoid duplicate attribute names within a pattern view.
          _forEachInstanceProperty__default["default"](attrJsonsInEdgeSet).call(attrJsonsInEdgeSet, function (attrJson) {
            var _context7;
            attrJson.AttributeName = _concatInstanceProperty__default["default"](_context7 = "".concat(edgeSet.alias, "_")).call(_context7, attrJson.AttributeName);
          });
          attrJsons.push.apply(attrJsons, attrJsonsInEdgeSet);
        });

        // Each pattern view can be treated as a vertex data.
        vertexJsons.push(constructGSQLVertexJson(patternView.alias, attrJsons, patternView));
      });
      break;
  }
  return constructGraph(_concatInstanceProperty__default["default"](_context8 = "".concat(patternJson.name, "_")).call(_context8, aliasSchemaAffix), vertexJsons, edgeJsons);
}

/**
 * Construct a GSQL vertex json.
 *
 * PrimaryId is not used.
 *
 * @param {string} name
 * @param {GSQLAttributeJson[]} attributes
 * @param {(PatternVertexSetJson | PatternViewJson)} entity
 * @returns {GSQLVertexJson}
 */
function constructGSQLVertexJson(name, attributes, entity) {
  return {
    Name: name,
    PrimaryId: {
      AttributeName: 'pid',
      AttributeType: {
        Name: 'INT'
      }
    },
    Attributes: attributes,
    Config: {
      existentialCheck: entity.existentialCheck,
      patternId: entity.id
    }
  };
}

/**
 * Construct a GSQL edge json.
 *
 * IsDirected is not used.
 *
 * @param {string} name
 * @param {string} source
 * @param {string} target
 * @param {GSQLAttributeJson[]} attributes
 * @param {PatternEdgeSetJson} edge
 * @returns {GSQLEdgeJson}
 */
function constructGSQLEdgeJson(name, source, target, attributes, edge) {
  return {
    Name: name,
    ToVertexTypeName: source,
    FromVertexTypeName: target,
    IsDirected: false,
    Attributes: attributes,
    Config: {
      existentialCheck: edge.existentialCheck,
      patternId: edge.id
    }
  };
}

/**
 * Construct a Graph.
 *
 * @param {string} graphName
 * @param {GSQLVertexJson[]} vertexTypes
 * @param {GSQLEdgeJson[]} edgeTypes
 * @returns {Graph}
 */
function constructGraph(graphName, vertexTypes, edgeTypes) {
  var graphJson = {
    GraphName: graphName,
    VertexTypes: vertexTypes,
    EdgeTypes: edgeTypes
  };
  return new graph_model.Graph().loadFromGSQLJson(graphJson);
}

/**
 * Get a unique alias for given pattern entity or entity json.
 *
 * @export
 * @param {(PatternEntity | PatternEntityJson)} entity
 * @returns {string}
 */
function getPatternComponentAlias(entity) {
  var _context9;
  return entity.alias || _concatInstanceProperty__default["default"](_context9 = "".concat(aliasSchemaAffix, "_")).call(_context9, entity.id);
}

/**
 * Get attribute jsons from the vertex pattern or edge pattern.
 * Only retrieve attributes for single type vertex pattern or edge pattern.
 *
 * @param {Graph} schema
 * @param {(PatternVertexSetJson | PatternEdgeSetJson)} entity
 * @returns {GSQLAttributeJson[]}
 */
function getAttributeJsons(schema, entityJson) {
  var attrJsons = [];
  if ('vertices' in entityJson) {
    if (entityJson.vertices.length === 1) {
      var vertex = schema.getVertex(entityJson.vertices[0]);
      if (vertex) {
        var vertexJson = vertex.dumpToGSQLJson();
        attrJsons = vertexJson.Attributes;
        if (vertex.config && vertex.config.PRIMARY_ID_AS_ATTRIBUTE) {
          attrJsons.push(vertexJson.PrimaryId);
        }
      }
    }
  } else if ('edges' in entityJson) {
    if (entityJson.edges.length === 1) {
      var edge = schema.getEdge(entityJson.edges[0]);
      if (edge) {
        attrJsons = edge.dumpToGSQLJson().Attributes;
      }
    }
  }
  return _filterInstanceProperty__default["default"](attrJsons).call(attrJsons, function (json) {
    return _includesInstanceProperty__default["default"](attributeType_model.supportedTypesInExpression).call(attributeType_model.supportedTypesInExpression, json.AttributeType.Name);
  });
}

/**
 * Add the attachments of a vertex set to its attributes.
 *
 * @param {PatternVertexSetJson} vertexSet
 * @param {GSQLAttributeJson[]} attributes
 * @return {string}
 */
function addAttachmentsToAttributes(vertexSet, attributes) {
  var _context10;
  _forEachInstanceProperty__default["default"](_context10 = vertexSet.aggregations).call(_context10, function (agg) {
    var aggExprValueType = getAggregationExpressionValueTypeForOrderBy(agg.expression);
    if (aggExprValueType !== 'UNSUPPORTED') {
      attributes.push({
        AttributeName: agg.name,
        AttributeType: {
          Name: aggExprValueType
        }
      });
    }
  });
}

/**
 * Recursively get the value type of the given aggregation,
 * and filter it out if it's unsupported in order-by.
 *
 * @param {(AtomJson | ExpressionJson)} aggregationExpression
 * @return {string}
 */
function getAggregationExpressionValueTypeForOrderBy(aggExpressionJson) {
  var _context11, _context12, _context13, _context14, _context15, _context16, _context17;
  // TODO:  Support Datetime in the future with GSQL support.
  if (_includesInstanceProperty__default["default"](_context11 = ['IntConstant', 'IntParam']).call(_context11, aggExpressionJson.type)) {
    return 'INT';
  } else if (_includesInstanceProperty__default["default"](_context12 = ['RealConstant', 'RealParam']).call(_context12, aggExpressionJson.type)) {
    return 'DOUBLE';
  } else if (_includesInstanceProperty__default["default"](_context13 = ['StringConstant', 'StringParam']).call(_context13, aggExpressionJson.type)) {
    return 'STRING';
  } else if (_includesInstanceProperty__default["default"](_context14 = ['AttrVariableWithAlias', 'AttrVariable']).call(_context14, aggExpressionJson.type)) {
    return getDataTypeForOrderBy(aggExpressionJson.valueType);
  } else if (_includesInstanceProperty__default["default"](_context15 = ['BoolConstant', 'BoolParam', 'DatetimeConstant', 'DatetimeParam', 'AliasReference']).call(_context15, aggExpressionJson.type)) {
    return 'UNSUPPORTED';
  }
  if (aggExpressionJson.type === 'FunctionExpression') {
    var functionExpressionReturnType = expression_model.FunctionMetaInfo.get(aggExpressionJson.operator).returnType;
    return getDataTypeForOrderBy(functionExpressionReturnType);
  }
  var expressionValueType = _reduceInstanceProperty__default["default"](_context16 = _mapInstanceProperty__default["default"](_context17 = aggExpressionJson.operands).call(_context17, function (operand) {
    return getAggregationExpressionValueTypeForOrderBy(operand);
  })).call(_context16, function (a, b) {
    // Semantic check has already ensured that operands in one expression can only be all numbers or all strings.
    if (a === 'DOUBLE' || b === 'DOUBLE') {
      return 'DOUBLE';
    } else if (a === 'STRING' || b === 'STRING') {
      return 'STRING';
    } else if (a === 'INT' && b === 'INT') {
      return 'INT';
    }
  }, 'INT');
  return expressionValueType;
}

/**
 * Given a data type return the corresponding string value if it is supported in orderby.
 * If it is not supported return 'UNSUPPORTED'.
 *
 * @param {DataType} dataType
 * @return {string}
 */
function getDataTypeForOrderBy(dataType) {
  switch (dataType) {
    case dataType_enum.DataType.Int:
      return 'INT';
    case dataType_enum.DataType.Real:
      return 'DOUBLE';
    case dataType_enum.DataType.String:
      return 'STRING';
    default:
      return 'UNSUPPORTED';
  }
}

/**
 * Find pattern entity by id.
 *
 * @param {string} id
 * @param {PatternJson} patternJson
 * @returns {PatternEntityJson}
 */
function getPatternEntityJsonById(id, patternJson) {
  var entities = [];
  entities.push.apply(entities, _toConsumableArray__default["default"](patternJson.patternVertexSets));
  entities.push.apply(entities, _toConsumableArray__default["default"](patternJson.patternEdgeSets));
  return _findInstanceProperty__default["default"](entities).call(entities, function (entity) {
    return entity.id === id;
  });
}

exports.AliasSchemaType = AliasSchemaType;
exports.aliasSchemaAffix = aliasSchemaAffix;
exports.buildAliasSchema = buildAliasSchema;
exports.getPatternComponentAlias = getPatternComponentAlias;
